module.exports = __webpack_public_path__ + "static/media/lobby-tape.3bad7a2c.svg";